import { useEffect, type ReactNode } from "react";

type FbqFunction = {
  (...args: unknown[]): void;
  callMethod?: (...args: unknown[]) => void;
  queue?: unknown[];
  loaded?: boolean;
  version?: string;
  push?: (...args: unknown[]) => void;
};

declare global {
  interface Window {
    fbq?: FbqFunction;
    _fbq?: FbqFunction;
  }
}

interface FacebookPixelProps {
  children: ReactNode;
}

const FacebookPixel = ({ children }: FacebookPixelProps) => {
  useEffect(() => {
    if (!window.fbq) {
      const fbq: FbqFunction = function (...args: unknown[]) {
        if (fbq.callMethod) {
          fbq.callMethod(...args);
        } else {
          fbq.queue = fbq.queue || [];
          fbq.queue.push(args);
        }
      };

      fbq.push = fbq;
      fbq.loaded = true;
      fbq.version = "2.0";
      fbq.queue = [];

      window.fbq = fbq;
      window._fbq = fbq;

      const script = document.createElement("script");
      script.async = true;
      script.src = "https://connect.facebook.net/en_US/fbevents.js";
      document.head.appendChild(script);
    }

    window.fbq?.("init", "1034578559117715");
    window.fbq?.("track", "PageView");

    const noscriptImg = document.createElement("img");
    noscriptImg.height = 1;
    noscriptImg.width = 1;
    noscriptImg.style.display = "none";
    noscriptImg.src =
      "https://www.facebook.com/tr?id=1034578559117715&ev=PageView&noscript=1";

    document.body.appendChild(noscriptImg);

    return () => {
      if (document.body.contains(noscriptImg)) {
        document.body.removeChild(noscriptImg);
      }
    };
  }, []);

  return <>{children}</>;
};

export default FacebookPixel;
